<template>
  <v-dialog v-model="value" max-width="800" persistent overlay-color="rgba(0,0,0,0.8)" transition="dialog-transition">
    <v-card class="video-popup elevation-12">
      <v-card-title class="headline elevation-1 primary white--text">
        <h4 class="use-text-subtitle d-flex align-center">
          <v-icon class="me-2">mdi-video</v-icon>
          {{ title }}
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog" color="white">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </h4>
      </v-card-title>
      <v-card-text class="pa-0">
        <div class="video-wrapper">
          <iframe
            :src="videoUrl"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
// Video Dialog Styles
.video-popup {
  border-radius: 16px;
  overflow: hidden;

  .video-wrapper {
    position: relative;
    padding-bottom: 56.25%; // 16:9 aspect ratio
    height: 0;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;
    }
  }

  @include breakpoints-up(sm) {
    max-width: 800px;
  }

  @include breakpoints-down(xs) {
    margin: 16px;
    border-radius: 12px;
  }

  h4 {
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    overflow: hidden;
  }
}
</style>

<script>
export default {
  name: 'VideoDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Video'
    },
    videoUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    closeDialog() {
      this.$emit('input', false);
    }
  }
};
</script>